module.exports = __webpack_public_path__ + "static/img/Full-Body5.4300b380.jpg";